module.exports = __webpack_public_path__ + "static/picture_onmeasureapp.e5a19b1e.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/assets/img/picture_onmeasureapp.png
// module id = 570
// module chunks = 52172470407915